import ClipWebFlyer from "../assets/images/cw-flyer.png";
import JJCard from "../assets/images/jj-card.png";
import JJFlyer from "../assets/images/jj-flyer.png";
import ALCard from "../assets/images/al-card.png";
import AKSite from "../assets/images/ak-site.png";
import CWSite from "../assets/images/cw-site.png"
import MulliganSite from "../assets/images/mulligan-site.png"

const projectData = [
    // Sites Web
    { 
        slug: "Portfolio_Alexandre_Kotowicz_React", 
        index: 0, 
        image: AKSite, 
        texte: "Portfolio Alexandre Kotowicz",
        category: "web",
        description: "Portfolio interactif pour un développeur de jeux vidéo en recherche d'emploi"
    },
    { 
        slug: "Clip_Web_Site",
        index: 1, 
        image: CWSite,
        texte: "Site web Clip Web",
        category: "web",
        description: "Site vitrine professionnel développé avec React et optimisé SEO"
    },
    { 
        slug: "Mulligan_TCG_Site_Web",
        index: 2, 
        image: MulliganSite,
        texte: "Site web Mulligan TCG",
        category: "web",
        description: "Plateforme communautaire pour les joueurs de TCG en Normandie"
    },
    
    // Design Graphique
    { 
        slug: "Clip_Web_Flyer_Digital",
        index: 3, 
        image: ClipWebFlyer, 
        texte: "Flyer numérique Clip Web",
        category: "design",
        description: "Support de communication digital pour promouvoir mes services freelance"
    },
    { 
        slug: "JJ_Detailing_Carte_Visite",
        index: 4, 
        image: JJCard, 
        texte: "Carte de visite JJ Detailing",
        category: "design",
        description: "Identité visuelle professionnelle pour une entreprise de detailing"
    },
    { 
        slug: "JJ_Detailing_Flyer",
        index: 5, 
        image: JJFlyer, 
        texte: "Flyer recto/verso JJ Detailing",
        category: "design",
        description: "Support print pour promouvoir les services de detailing automobile"
    },
    { 
        slug: "AL_Batiment_Carte_Visite",
        index: 6, 
        image: ALCard, 
        texte: "Carte de visite AL Bâtiment",
        category: "design",
        description: "Création complète d'identité visuelle pour une entreprise du bâtiment"
    },
];

export default projectData;